import * as React from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment'
import * as _ from 'lodash'
import IosDesktopOutline from 'react-ionicons/lib/IosDesktopOutline'
import IosCashOutline from 'react-ionicons/lib/IosCashOutline'

import { durationToDDHHMMSSMS, ContactHistoryT } from './ContactTab'
import { yourContact, contactDate, styles } from './style'
import { css } from 'glamor'
import { extractImpliedLineDate, extractStartTime, getJobMoveDate } from '../JobUtils'
import { formatDate } from '../../../../utils/utilsT'
import { JobStatusT, JobT } from '../../../../types/Job'
import config from '../../../../constants/config'

export interface IFormSubmissionProps {
    job: JobT
    item: ContactHistoryT

}
const optionsQoute = {
    apartment: {
        "ST": "Studio",
        "A1": "1 Bedroom",
        "A2": "2 Bedrooms",
        "A3": "3+ Bedrooms",
    },
    house: {
        "H1": "1 Bedroom",
        "H2": "2 Bedrooms",
        "H3": "3 Bedrooms",
        "H4": "4+ Bedrooms",
    }
}
const initMeta = {
    addressFrom: "",
    addressTo: "",

    noAddressTo: "",
    moveDate: "",
    moveType: "",
    homeSize: "",

}


const ContactFormSubmission: React.FC<IFormSubmissionProps> = ({ job, item }) => {
    const [meta, setMeta] = React.useState(initMeta)


    React.useEffect(() => {

        if (!_.isEmpty(item.meta)) {
            setMeta({ ...initMeta, ...item.meta })
        }
    }, [item])




    const getLables = (): { moveType: string, homeSize: string } => {
        let moveTypeOptions = optionsQoute[`${meta.moveType}`]

        let homeSize = ""
        if (!_.isEmpty(moveTypeOptions) && moveTypeOptions != undefined) {
            homeSize = optionsQoute[`${meta.moveType}`][`${meta.homeSize}`]
        }

        return {
            moveType: meta.moveType,
            homeSize: homeSize,
        }
    }



    return (
        <div className={` ${item.direction == "outgoing" ? css(styles.itemContact, styles.right) : styles.itemContact}`} >
            <div className="contact-header">
                <span className="title"><IosDesktopOutline />  <strong>{item.sender.firstName} {item.sender.lastName}</strong>
                    <span className="date">  {formatDate(moment.utc(item.date), config.dateFormat.dateTime, true)}</span>
                </span>
                {(job.closedIn.communicationId == item.id && job.jobStatus == JobStatusT.scheduled) && <span className="closed-in"> <IosCashOutline color='green' />  Closed in <strong style={{ color: 'green' }}> {durationToDDHHMMSSMS(job.closedIn.time)}</strong></span>}
            </div>

            <h4>Form Submission</h4>
            <p>
                <strong>{item.sender.firstName} {item.sender.lastName}</strong> inquired about a {`${getLables().homeSize}`} {`${getLables().moveType}`} move at {getJobMoveDate(job, "h:mm A on MMM DD, YYYY", true)}.
            </p>
            <Form>
                <Form.Group>
                    <Form.Label>{_.isArray(job.locations) && job.locations[1] ? "Source Address" : "Address"}</Form.Label>
                    <Form.Control
                        disabled
                        value={_.isArray(job.locations) && job.locations[0] ? job.locations[0].address : ""} />
                </Form.Group>
                {_.isArray(job.locations) && job.locations[1] && <Form.Group>
                    <Form.Label>Destination Address</Form.Label>
                    <Form.Control
                        disabled
                        value={job.locations[1].address} />
                </Form.Group>
                }
            </Form>
        </div>

    );
}

export default ContactFormSubmission;
export { ContactFormSubmission };